<template>
	<!-- Exportar: encola el libro completo del reporte (decisiones §34) y lo
		descarga cuando está listo. El estado vive en reportsFilters, así que
		todos los botones (header de los tabs, drawers, Clasificador) muestran
		la misma corrida y el polling sigue aunque el usuario cambie de vista. -->
	<div v-if="isExporting" class="export_progress" role="status" aria-live="polite">
		<span class="export_progress_text">
			Generando el archivo… {{ exportPercent }} %
		</span>
		<span v-if="exportSheet" class="export_progress_sheet">{{ exportSheet }}</span>
		<span class="export_progress_bar">
			<span class="export_progress_fill" :style="{ width: exportPercent + '%' }" />
		</span>
	</div>
	<button v-else class="theme_btn_white is-flex is-align-items-center export_btn"
		type="button"
		title="Descargar el reporte en Excel"
		@click="exportReport">
		<DownloadFile class="mr-2" style="width: 16px; height: 16px;" />
		Exportar
	</button>
</template>

<script>
import DownloadFile from "@/components/svg/DownloadFile.vue";

export default {
	name: "ReportExportButton",
	components: { DownloadFile },
	props: {
		// Sin calendario propio (Clasificador): corta el libro al último mes
		// con datos en vez del mes de corte del reporte.
		toLastDataMonth: { type: Boolean, default: false },
	},
	computed: {
		// Acceso defensivo: los specs de los headers que lo contienen montan
		// sin store.
		reportsFilters() {
			return (this.$store && this.$store.state.reportsFilters) || null;
		},
		isExporting() {
			return Boolean(this.reportsFilters && this.reportsFilters.exportState === "running");
		},
		exportPercent() {
			const progress = this.reportsFilters && this.reportsFilters.exportProgress;
			return progress ? Math.round(progress.percent) : 0;
		},
		exportSheet() {
			const progress = this.reportsFilters && this.reportsFilters.exportProgress;
			return progress ? progress.sheet : "";
		},
	},
	methods: {
		exportReport() {
			if (this.isExporting || !this.$store) return;
			this.$store.dispatch("reportsFilters/exportReport",
				{ toLastDataMonth: this.toLastDataMonth });
		},
	},
};
</script>

<style scoped lang="scss">
.theme_btn_white {
	background: var(--report-bg);
	border: 1px solid var(--report-border);
	border-radius: 8px;
	padding: 8px 16px;
	font-weight: 500;
	color: var(--report-text-strong-2);
	box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
	cursor: pointer;

	&:hover {
		background: var(--report-surface);
	}
}

// Progreso del export: reemplaza al botón mientras la task genera el
// archivo y desaparece cuando el navegador empieza la descarga.
.export_progress {
	display: flex;
	flex-direction: column;
	gap: 4px;
	min-width: 220px;
	padding: 6px 12px;
	border: 1px solid var(--report-border);
	border-radius: 8px;
	background: var(--report-surface);
	font-size: 0.85rem;
	color: var(--report-text-strong-2);
}

.export_progress_sheet {
	font-size: 0.75rem;
	color: var(--report-text-muted, var(--report-text-strong-2));
}

.export_progress_bar {
	display: block;
	height: 4px;
	border-radius: 2px;
	background: var(--report-border);
	overflow: hidden;
}

.export_progress_fill {
	display: block;
	height: 100%;
	background: var(--report-primary, currentColor);
	transition: width 0.4s ease;
}
</style>
